// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "7ece908e",
    "hash": "7ece908e",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "7ece908e",
    "semverString": null,
    "timestamp": 1758486112378,
    "dateStr": "Sun Sep 21 2025 20:21:52 GMT+0000 (Coordinated Universal Time)"
};
/* tslint:enable */
